import React, { useEffect, useState } from "react";
import { Table, Row, Col, Button, Nav, NavItem, NavLink } from "@/Components/ui";;
import classnames from "classnames";
import { Link } from 'react-router-dom';

import { useTable } from 'react-table'
import { BsSortDownAlt, BsSortUp } from "react-icons/bs";
import QueryString from "qs";

const compareObjects = (objectA, objectB) => {
    let aProperties = Object.getOwnPropertyNames(objectA);
    let bProperties = Object.getOwnPropertyNames(objectB);
    if (aProperties.length !== bProperties.length) {
        return false; // then the objects are not equals
    }
    for (let i = 0; i < aProperties.length; i++) {
        let propName = aProperties[i];
        if (objectA[propName] !== objectB[propName]) {
            return false;
        }
    }
    return true;
}

const splitKeyProp = (props) => {
    const { key, ...rest } = props;
    return { key, props: rest };
}

const ServerPaginatedTable = ({ id, url, columns, categories = [
    { id: 0, title: "전체", search: "", state: "", icon: "ri-store-2-fill" }
],
    data, previous, next, count, serachable = true, tableQuery,
    onRequestData = () => { }, onChangeQuery = () => { }
}) => {
    const pageSize = 15 // same as server setting

    // const [search, setSearch] = React.useState(initialSearch);
    // const [ordersortQ, setOrdersortQ] = React.useState(defaultSortOrderQ);

    const [queryParam, setQueryParam] = useState(tableQuery || {})
    // const [category, setCategory] = React.useState(0);
    const [tabId, setTabId] = React.useState(0);
    const [focusPage, setFocusPage] = React.useState(1);

    const _data = data.map((el, i) => (-1))
    const [sortState, setSortState] = React.useState([..._data])

    useEffect(() => {
        /// tableQuery 를 변경하는 것은 테이블 스테이트를 초기화하는 것과 같다고 생각하자.
        if (tableQuery) {
            // console.log("tableQuery updated", tableQuery)
            setQueryParam({ ...tableQuery })
        }
    }, [tableQuery])

    // useEffect(() => { // 이렇게 하는 순간 감당할 수 없는 버그가 속출한다. 
    //     if (!compareObjects(tableQuery, queryParam)) {
    //         console.log("tableQuery", tableQuery)
    //         const curCat = categories.length ? categories[tabId] : {}
    //         const param = { ...tableQuery, state: curCat.state, search: curCat.search }
    //         const _q = QueryString.stringify()
    //         console.log("onRequestData", `${url}/?${_q}`)
    //         onRequestData(`${url}/?${_q}`);
    //         setQueryParam({...tableQuery})
    //         setFocusPage(1)
    //     }
    // }, [tableQuery, queryParam, categories, tabId])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data });

    const searchByKeyPress = (e) => {
        if (e.key === "Enter") {
            const _q = QueryString.stringify({ ...queryParam })
            onRequestData(`${url}/?${_q}`);
            onChangeQuery(queryParam)
            setFocusPage(1)
        }
    }

    const resetSearch = () => {
        const param = { ...queryParam, search: "" }
        const _q = QueryString.stringify(param)
        onRequestData(`${url}/?${_q}`);
        setQueryParam(param)
        onChangeQuery(param)
        setFocusPage(1)
    }

    const toggleTab = (_id, _title, _search, _state) => {
        setTabId(_id)
        const curCat = categories.length ? categories[_id] : {}
        const param = { ...queryParam, state: curCat.state, search: curCat.search }
        const _q = QueryString.stringify(param)
        console.log("toggleTab", `${url}/?${_q}`)
        onRequestData(`${url}/?${_q}`);
        setQueryParam(param)
        onChangeQuery(param)
        setFocusPage(1)
    }

    // Defensive: normalize count to a safe non-negative integer
    const parsedCount = parseInt(count, 10);
    const safeCount = (Number.isFinite(parsedCount) && parsedCount > 0) ? parsedCount : 0;
    const totalPages = Math.ceil(safeCount / pageSize);

    return (
        <React.Fragment>
            {serachable ? <Row>
                <Col md={5}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                        <input
                            onChange={(e) => {
                                // setSearch(e.target.value);
                                setQueryParam({ ...queryParam, search: e.target.value })
                            }}
                            id="search-bar-0"
                            type="text"
                            className="form-control search /"
                            placeholder={`${count} Search...`}
                            value={queryParam.search ? queryParam.search : ""}
                            onKeyPress={searchByKeyPress}
                        />
                        <Button  onClick={() => {
                            const _q = QueryString.stringify(queryParam)
                            onRequestData(`${url}/?${_q}`);
                            onChangeQuery(queryParam)
                            setFocusPage(1);
                        }} color="soft-light" className="me-1 text-dark">
                            <i className="bx bx-search-alt search-icon"></i>
                        </Button>
                        <Button  onClick={() => {
                            resetSearch();
                        }} color="soft-secondary" className="me-1">
                            <i className="bx bx-reset"></i>
                        </Button>
                    </div>
                </Col>
            </Row> : null}

            {categories.length ? <Nav
                className="nav-tabs nav-tabs-custom nav-success"
                role="tablist"
                style={{ marginBottom: "18px" }}
            >
                {categories.map((el, i) => {
                    return (<NavItem key={i}>
                        <NavLink
                            className={classnames("nav-tab-link",
                                { active: tabId === el.id })}
                            onClick={() => {
                                toggleTab(el.id, el.title, el.search, el.state);
                            }}
                            href="#"
                        >
                            <i className={`${el.icon} me-1 align-bottom`}></i>{" "}
                            {el.title}
                        </NavLink>
                    </NavItem>)
                })}
            </Nav> : ""}

            <div className="w-full overflow-x-auto">
                <Table id={id} {...getTableProps()} className="w-full mb-0 border-y border-slate-200">
                    <thead className="bg-slate-50 border-b border-slate-200 text-slate-500">
                        {headerGroups.map((headerGroup, idx) => {
                            const headerGroupProps = splitKeyProp(headerGroup.getHeaderGroupProps());
                            return (
                                <tr {...headerGroupProps.props} key={headerGroupProps.key || `${headerGroup.id}-${idx}`}>
                                    {headerGroup.headers.map((column, col_i) => {
                                        const headerProps = splitKeyProp(column.getHeaderProps());
                                        return (
                                            <th
                                                {...headerProps.props}
                                                key={headerProps.key || column.id}
                                                className="h-12 px-4 text-left align-middle font-medium"
                                            >
                                                <div className="flex items-center">
                                                    {column.render('Header')}
                                                    {(col_i > 0 && columns[col_i].id) ?
                                                        <span
                                                            className="ml-2 cursor-pointer inline-flex"
                                                            style={{ color: sortState[col_i] === -1 ? "#cbd5e1" : "#475569" }}
                                                            onClick={() => {
                                                                const param = { ...queryParam, sort: column.id, order: sortState[col_i] ? "asc" : "desc" }
                                                                const _q = QueryString.stringify(param)
                                                                onRequestData(`${url}/?${_q}`);
                                                                setQueryParam(param)
                                                                onChangeQuery(param)
                                                                setFocusPage(1);

                                                                sortState[col_i] = !sortState[col_i]
                                                                setSortState({ ...sortState })
                                                            }}>{sortState[col_i] ? <BsSortDownAlt /> : <BsSortUp />}</span> : ""}
                                                </div>
                                            </th>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </thead>
                    <tbody {...getTableBodyProps()} className="divide-y divide-slate-100">
                        {rows.map((row, i) => {
                            prepareRow(row)
                            const rowProps = splitKeyProp(row.getRowProps());
                            return (
                                <tr {...rowProps.props} key={rowProps.key || row.original['id'] || i} className="hover:bg-slate-50/80 transition-colors">
                                    {row.cells.map((cell, idx) => {
                                        const cellProps = splitKeyProp(cell.getCellProps());
                                        return (
                                            <td
                                                {...cellProps.props}
                                                key={cellProps.key || idx}
                                                className="p-4 align-middle text-slate-700"
                                            >
                                                {cell.render('Cell')}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center p-2">

                {
                    (data.length > 0) ?
                        <Col className="col-md-auto">
                            <div className="d-flex gap-1">
                                {previous ? <Button className="page-item pagination-prev" style={{ marginRight: "12px" }} onClick={() => {
                                    onRequestData(previous); setFocusPage(focusPage - 1);
                                }} disabled={!previous}>
                                    {'<'}
                                </Button> : ""}

                                <ul className="pagination listjs-pagination mb-0">
                                    {(() => {
                                        if (!totalPages) return null;
                                        let pages = Array.from({ length: totalPages }, (_, i) => i);

                                        let from = Math.floor((focusPage - 1) / 10) * 10;
                                        if (pages.length > from + 10) {
                                            pages = pages.slice(from, from + 10);
                                            pages.push("...");
                                        } else {
                                            pages = pages.slice(from);
                                        }
                                        return (<>{
                                            pages.map((page, idx) => {
                                                if (page === "...") return <li key={idx}>...</li>;
                                                const param = { ...queryParam, page: page + 1 };
                                                const _q = QueryString.stringify(param);
                                                return (
                                                    <li className={(focusPage === page + 1) ? "active" : ""} key={idx}>
                                                        <Button className="page" onClick={() => {
                                                            onRequestData(`${url}/?${_q}`);
                                                            setFocusPage(page + 1);
                                                        }}>{page + 1}</Button>
                                                    </li>
                                                );
                                            })
                                        }</>);
                                    })()}
                                </ul>

                                {next ? <Button className="page-item pagination-next" onClick={() => {
                                    onRequestData(next); setFocusPage(focusPage + 1)
                                }} disabled={!next}>
                                    {'>'}
                                </Button> : ""}
                            </div>
                        </Col> :
                        null
                }
            </Row>
        </React.Fragment>
    );
}

export default ServerPaginatedTable;
